import { createSlice } from "@reduxjs/toolkit";

const initialState: ISiteState = {
  data: null,
  pageSize: 0,
  pageNumber: 0,
  totalCount: 0,
  showLoading: {
    sourceAction: "",
    state: false,
  },
  isLoading: false,
  isSuccess: false,
  Details: null,
};

export const siteSlice = createSlice({
  name: "site",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      const { sourceAction, isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: sourceAction,
        state: true,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    resetLoading: (state, action) => {
      const { isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: "",
        state: false,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    replaceSite: (state, action) => {
      const { data, pageSize, pageNumber, totalCount } = action.payload;
      state.data = data;
      state.pageSize = pageSize;
      state.pageNumber = pageNumber;
      state.totalCount = totalCount;
    },
    addSite: (state, action) => {
      const newItem = action.payload.data;
      if (state.data && state.data.length > state.pageSize) {
        state.data.pop();
      }
      state.data = state.data ? [newItem, ...state.data] : [newItem];
      state.totalCount = state.totalCount + 1;
    },
   updateSite: (state, action) => {
     const { localID, data } = action.payload;
     if (localID !== undefined && localID >= 0 && state.data) {
      state.data = state.data.map((item, index) =>
      index === localID ? data : item
      );
      state.Details = data;
      state.data = null;
     }
    },
    deleteSite: (state, action) => {
      const siteToRemove: ISite = action.payload.data;
      const newSiteData =
        state.data &&
        state.data.filter((site: ISite) => {
          return site.id !== siteToRemove.id;
        });
      state.data = newSiteData;
      state.totalCount = state.totalCount - 1;
    },
    setSiteDetails: (state, action) => {
      state.Details = action.payload.data;
    },
  },
});

export const siteActions = siteSlice.actions;
export default siteSlice.reducer;